export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'en',
  messages: {
    en: {
      passionEquip: 'Passion Equip',
      passionEquipHome: 'Passion Equip Home',
      openMainMenu: 'Open main menu',
      close: 'Close',
      about: 'About',
      aboutPassion: 'About Passion',
      privacyPolicy: 'Privacy Policy',
      discover: 'Discover',
      today: 'Today',
      profile: 'Profile',
      album: 'Album',
      talks: 'Talks',
      worship: 'Worship',
      scripture: 'Scripture',
      song: 'Song',
      songs: 'Songs',
      topics: 'Topics',
      quote: 'Quote',
      search: 'Search',
      lyrics: 'Lyrics',
      viewMore: 'View More',
      allCollections: 'All Collections',
      featuredResources: 'Featured Resources',
      enterSearch: 'Search...',
      enterSearchType: 'Search {type}...',
      searchResults: 'Search Results',
      searchResultsX: 'Search Results for: {query}',
      mostRecent: 'Most Recent',
      noResults: 'No results.',
      people: 'People',
      filterByPeople: 'Filter by People',
      filterByType: 'Filter by Type',
      discussionQuestions: 'Discussion Questions',
      podcastEpisode: 'Podcast Episode',
      podcastEpisodes: 'Podcast Episodes',
      keyTakeaway: 'Key Takeaway',
      toggleBookmark: 'Toggle Bookmark',
      resumeJourney: 'Resume your Journey',
      more: 'More',
      myProfile: 'My Profile',
      profileSettings: 'Profile Settings',
      personalInformation: 'Personal Information',
      name: 'Name',
      or: 'or',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      reEnterPassword: 'Re-Enter Password',
      updateSettings: 'Update Settings',
      socialSignIn: 'Social Sign-In',
      notificationPreferences: 'Notification Preferences',
      weeklyDigest: 'Weekly Digest',
      weeklyDigestNotification: 'A summary of top resources from Passion Equip, delivered weekly.',
      passionDailyNotification: 'Daily devotional emails with prayer and inspiration from The Jesus Bible.',
      trackDay: 'Track Day',
      trackDays: 'Track Days',
      track: 'Track',
      tracks: 'Tracks',
      talk: 'Talk',
      overview: 'Overview',
      message: 'Talk',
      messages: 'Talks',
      messageAlternate: 'Sermon',
      article: 'Article',
      articles: 'Articles',
      articleAlternate: 'Read',
      podcast: 'Podcast',
      podcasts: 'Podcasts',
      collection: 'Collection',
      collections: 'Collections',
      aboutThisPodcast: 'About This Podcast',
      aboutThisStudy: 'About This Study',
      prayer: 'Prayer',
      sessionN: 'Day {n}',
      dayN: 'Day {n}',
      nDays: '{n} Day | {n} Days',
      beginStudy: 'Begin Study',
      nextSession: 'Complete Day {n}',
      finishSession: 'Complete Study',
      continueStudy: 'Continue Study',
      completionPercent: '{n}% Complete',
      saveStudy: 'Save Study',
      watchStudy: 'Watch Study',
      study: 'Study',
      summary: 'Summary',
      listenOnSpotify: 'Listen on Spotify',
      listenOnGooglePodcasts: 'Listen on Google Podcasts',
      listenOnApplePodcasts: 'Listen on Apple Podcasts',
      listenOnYouTubePodcasts: 'Listen on YouTube',
      nResources: '1 Resource | {n} Resources',
      nSessionsWith: '1 Day with {author} | {n} Days with {author}',
      nMins: '{n} Min | {n} Mins',
      contentTypeByAuthor: '{type} by {author}',
      nSessions: '1 Day | {n} Days',
      nSession: 'Day {n}',
      shareStudy: 'Share Study',
      studyOverview: 'Study Overview',
      studies: 'Studies',
      episode: 'Episode',
      episodes: 'Episodes',
      video: 'Video',
      videos: 'Videos',
      devotional: 'Devotional',
      featuredContributors: 'Featured Contributors',
      contributors: 'Contributors',
      resources: 'Resources',
      clearFilters: 'Clear Filters',
      introduction: 'Introduction',
      watchMessage: 'Watch Message',
      readArticle: 'Read Article',
      startStudy: 'Start Study',
      relatedResources: 'Related Resources',
      scriptureReferences: 'Scripture References',
      passionCityChurch: 'Passion City Church',
      passionConferences: 'Passion Conferences',
      passionPublishing: 'Passion Publishing',
      passionResources: 'Passion Resources',
      sixsteprecords: 'sixsteprecords',
      guest: 'Guest',
      home: 'Home',
      terms: 'Terms',
      privacy: 'Privacy',
      minuteAbbr: 'MIN',
      bookmarked: 'Bookmarked',
      hello: 'Hello, <span class="text-blurple-500">{user}</span>',
      editProfile: 'Edit Profile',
      support: 'Support',
      xM: '{n}M',
      createFreeAccount: 'Create your free account',
      sayOnTrackWithPassionEquip: 'Stay on track with Passion Equip',
      trackProgress: 'Create a profile or sign in to track your progress and access your bookmarked content.',
      createAProfile: 'Create a Profile',
      clickHereToCreateAccount: 'Click here to create your account',
      signInToAccount: 'Sign in to your account',
      alreadyUsingPassionEquip: 'Already using Passion Equip?',
      newToPassionEquip: 'New to Passion Equip?',
      forgotPassword: 'Forgot Password?',
      resetPassword: 'Reset Password',
      signinHere: 'Sign in here',
      signupHere: 'Sign up here',
      signinWithFacebook: 'Sign in with Facebook',
      getStartedWithFacebook: 'Continue with Facebook',
      signinWithGoogle: 'Sign in with Google',
      getStartedWithGoogle: 'Continue with Google',
      getStartedWithEmail: 'Continue with Email',
      signUpAndSubscribe: 'Sign Up & Subscribe',
      orUseEmailInstead: 'Or use email instead',
      resetEmailSent: 'If email exists, you will receive a reset password link.',
      password: 'Password',
      createProfile: 'Create Profile',
      signin: 'Sign In',
      signup: 'Sign Up',
      signupInfo: 'When you create a profile, we\'ll keep you updated on the latest news and updates from Passion. You can unsubscribe at any time.',
      signout: 'Sign Out',
      loadMore: 'View More',
      loading: 'Loading...',
      anonymousUser: 'Anonymous User',
      haveAProfile: 'Have a profile?',
      share: 'Share',
      submit: 'Submit',
      emailAddress: 'Email Address',
      passionDaily: 'Passion Daily',
      noteworthy: 'Noteworthy',
      exploreTopics: 'Explore Topics',
      aroundTheMovement: 'Around the Movement',
      subscribe: 'Subscribe',
      latestResourceWeekly: 'Get the Latest Resources Weekly',
      signupDigest: 'Stay on Track with Equip',
      signupDigestContinue: 'Continue to deepen your faith with new messages, studies, and  articles directly to your inbox.',
      personalizeYourExperience: 'Personalize your experience with Passion Equip',
      subscribeToStudies: 'Subscribe to Biblical and Topical Studies',
      bookmarkForLater: 'Bookmark content for later',
      getRecommendations: 'Get personalized recommendations',
      passionEquipExistsTo: 'Passion Equip exists to help people around the globe know and draw closer to Jesus.',
      learnMoreMovement: 'Learn more about The Passion Movement.',
      signingout: 'Signing out...',
      thanksForSubscribing: 'Thanks for subscribing!',
      errorSubscribing: 'Error subscribing, please try again later.',
      errorStartingStudy: 'Error starting study, please try again.',
      errorCompletingDay: 'Error completing day, please try again.',
      journeyJoinUs: 'Join us for an {days}-day email journey through {title}',
      journey: 'Would you like to join Passion Equip for an {days}-day email journey through {title}?',
      journeyMobile: 'Sign up for an {days}-day email journey through {title}?',
      journeySubscribeSuccess: 'You’ve successfully subscribed to receive the {days}-day email journey through {title}.',
      yes: 'Yes',
      done: 'Done',
    },
  },
}))
